import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonModal,
  IonSearchbar,
  IonTitle,
  IonToolbar,
  IonLabel,
} from "@ionic/react";
import { radioButtonOffOutline, radioButtonOnOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { DesplegableModel } from "../../interfaces";

interface ContainerProps {
  array: DesplegableModel[];
  mostrarTodos: boolean;
  mostrarSearch: boolean;
  id: string;
  value: number;
  open: boolean;
  setOpen: (open: boolean) => void;
  handleChange: (value: number, id: string) => void;
}
const CustomDesplegable: React.FC<ContainerProps> = ({
  array,
  mostrarTodos,
  mostrarSearch,
  id,
  value,
  handleChange,
  open,
  setOpen,
}) => {
  const [texto, setTexto] = useState("");
  const [searchText, setSearchText] = useState("");
  const [opcionesValidas, setOpcionesValidas] = useState<DesplegableModel[]>([]);

  const onHandleChange = (value: any, textLabel: string) => {
    handleChange(value, id);
    setTexto(textLabel);
    setOpen(false);
  };

  const FiltrarOpciones = (ev: any) => {
    const texto = ev.target.value;
    let opciones: DesplegableModel[] = array.filter((item: DesplegableModel) =>
      item.text.toLowerCase().includes(texto.toLowerCase())
    );
    setOpcionesValidas(opciones);
    setSearchText(texto);
  };

  useEffect(() => {
    if (open) {
      setOpcionesValidas(array);
    }
    if (texto === "" || (value === -1 && !mostrarTodos)) {
    }
  }, [open]);

  return (
    <IonModal isOpen={open} onDidDismiss={() => setOpen(false)}>
      <IonHeader>
        <IonToolbar>
          <IonButton slot="end" fill="clear" expand="full" onClick={() => setOpen(false)}>
            Cancelar
          </IonButton>
          <IonTitle>{id}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {mostrarSearch && (
          <IonSearchbar
            value={searchText}
            onIonInput={(ev) => FiltrarOpciones(ev)}
            debounce={500}
            placeholder="Buscar por nombre"
          />
        )}
        <IonList>
          {mostrarTodos && (
            <IonItem key={-1} button onClick={() => onHandleChange(-1, "Mostrar todos")}>
              <IonLabel>Mostrar todos</IonLabel>
              <IonIcon
                slot="start"
                icon={-1 !== value ? radioButtonOffOutline : radioButtonOnOutline}
                size="large"
              />
            </IonItem>
          )}
          {opcionesValidas?.map((item: DesplegableModel) => (
            <IonItem
              key={item.codigo}
              button
              onClick={() => onHandleChange(item.codigo, item.text)}
            >
              {item.imageSrc && (
                <img
                  src={item.imageSrc}
                  alt={item.text}
                  className="prestador-avatar prestador-avatar--list"
                />
              )}
              <IonLabel>
                <h2>{item.text}</h2>
                {item.nota && <small>{item.nota}</small>}
              </IonLabel>
              <IonIcon
                slot="start"
                icon={item.codigo !== value ? radioButtonOffOutline : radioButtonOnOutline}
                size="large"
              />
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonModal>
  );
};

export default CustomDesplegable;
